import { scope } from '#components/generics/js/selectors/scope.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import resize from '@mailobj-browser/front/js/events/types/resize.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { start } from './action_x.js'
import { show as showCtrl } from './controls.js'
import { reset } from './gallery.js'

const nodes = new WeakMap()

const onResize = object(listener, {
  type: resize,
  passive,
  task: (defaultView) => {
    const { top } = defaultView
    const { document } = top
    const node = nodes.get(document)

    if (node) {
      showCtrl(node)
    }
  }
})

export default async (node, scopeProps) => {
  if (!scopeProps) {
    scopeProps = scope(node)
  }
  const { dial, ws_url } = scopeProps

  if (ws_url) {
    await start(node, scopeProps, true)

    const { ownerDocument } = node
    const { defaultView } = ownerDocument

    showCtrl(node)
    nodes.set(ownerDocument, node)
    onResize.listen(defaultView)

    queueMicrotask(async () => {
      await removed(node)
      if (nodes.get(ownerDocument) === node) {
        onResize.forget(defaultView)
        nodes.delete(node)
      }
    })

    if (dial) {
      reset()
    }
  }
}